module.exports = __webpack_public_path__ + "static/media/55_000022.edb78ce7.jpg";